import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { useAdTeamStore } from 'src/stores/AdTeamStore';

const menuProps = {
    PaperProps: {
        sx: {
          // maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:'46px',
    minWidth: '200px',
    textAlign:'left',
    justifyContent:'center',
    border: '1.5px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
}

const DropBoxSx = {
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

const ModalSelectManager = () => {
    const setField = useAdTeamStore((state)=>state.setField)
    const memberList = useAdTeamStore((state)=>state.memberList)
    const manager_uid = useAdTeamStore((state)=>state.manager_uid)
    const handleChange = (e:SelectChangeEvent)=>{
        setField('manager_uid',e.target.value)
    }
  return (
      <Select
          displayEmpty
          value={manager_uid ? manager_uid.toString() : ''}
          onChange={handleChange}
          renderValue={(value) => {
            const selectedMember = memberList.find((m) => m.uid === Number(value));
            return selectedMember?.user_name || '팀장 선택';
          }}
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
            <MenuItem value="" sx={DropBoxSx}>
              팀장 선택
            </MenuItem>
          {memberList.map((content, index) => (
              <MenuItem value={content.uid} sx={DropBoxSx} key={index}>
                  {content.user_name}
              </MenuItem>
          ))}
      </Select>
  )
}

export default ModalSelectManager